<div class="container">
    <div class="row">
        <div class="col-lg-9 col-md-12 col-sm-12 mt-5 py-2">
            <!-- collections -->
            <div class="row div-collect">
                <div class="col-md-12 col-lg-12">
                    <h1 class="h1-title">collections</h1>
                </div>
                <div class="col-md-6 col-lg-6 card-collections">
                    <mat-card class="example-card">
                        <div class="d-flex bd-highlight up-header mt-1 mb-3">
                            <div class="bd-highlight">Updated 5 min.</div>
                            <div class="ml-auto bd-highlight">25 packages</div>
                        </div>
                        <mat-card-header class="card-header-mat">
                            <div mat-card-avatar class="example-header-image">
                                <img
                                    src="../../../assets/images/user-female.png"
                                    alt="User image card"
                                    class="person-card-photo"
                                />
                                <span class="person-card-name">Andrew Devi</span>
                            </div>
                        </mat-card-header>
                        <img
                            mat-card-image
                            class="pb-2"
                            src="../../../assets/images/card-img.png"
                            alt="Photo of a Shiba Inu"
                        />
                        <mat-card-content>
                            <div class="content-title mb-2">Weather data collection</div>
                            <div class="content-actions">
                                <button
                                    mat-fab
                                    class="person-menu"
                                    [class.yellow]="isFavorite"
                                    aria-label="Example icon button with a delete icon"
                                    (click)="makeFavorite()"
                                >
                                    <mat-icon>star_border</mat-icon>
                                </button>
                                <span class="px-2 content-nr">47</span>
                            </div>
                            <div class="content-list">
                                <ul style="list-style-type: none; padding-left: 0px">
                                    <li>package title 1</li>
                                    <li>package title 2</li>
                                    <li>package title 3</li>
                                    <li>package title 4</li>
                                    <li>more...</li>
                                </ul>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="col-md-6 col-lg-6 card-collections">
                    <mat-card class="example-card">
                        <div class="d-flex bd-highlight up-header mt-1 mb-3">
                            <div class="bd-highlight">Updated 5 min.</div>
                            <div class="ml-auto bd-highlight">25 packages</div>
                        </div>
                        <mat-card-header class="card-header-mat">
                            <div mat-card-avatar class="example-header-image">
                                <img
                                    src="../../../assets/images/user-female.png"
                                    alt="User image card"
                                    class="person-card-photo"
                                />
                                <span class="person-card-name">Andrew Devi</span>
                            </div>
                        </mat-card-header>
                        <mat-card-content>
                            <div class="content-title mb-2">Weather data collection</div>
                            <div class="content-actions">
                                <button
                                    mat-fab
                                    class="person-menu"
                                    [class.yellow]="isFavorite"
                                    aria-label="Example icon button with a delete icon"
                                    (click)="makeFavorite()"
                                >
                                    <mat-icon>star_border</mat-icon>
                                </button>
                                <span class="px-2 content-nr">47</span>
                            </div>
                            <div class="content-list">
                                <ul style="list-style-type: none; padding-left: 0px">
                                    <li>package title 1</li>
                                    <li>package title 2</li>
                                    <li>package title 3</li>
                                    <li>package title 4</li>
                                    <li>package title 5</li>
                                    <li>package title 6</li>
                                    <li>package title 7</li>
                                    <li>package title 8</li>
                                    <li>more...</li>
                                </ul>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <!-- collections -->

            <!-- packages -->
            <div class="row big-div-package mb-3">
                <div class="col-md-12 col-lg-12">
                    <h1 class="h1-title">packages</h1>
                </div>
                <div class="col-md-12 col-lg-12 pb-2 package-div">
                    <mat-card class="example-card">
                        <div class="d-flex bd-highlight up-header mt-1 mb-3">
                            <div class="bd-highlight">Updated 5 min.</div>
                            <div class="ml-auto bd-highlight">2 downloaded</div>
                        </div>
                        <mat-card-header class="card-header-mat">
                            <div mat-card-avatar class="example-header-image">
                                <img
                                    src="../../../assets/images/user-female.png"
                                    alt="User image card"
                                    class="person-card-photo"
                                />
                                <span class="person-card-name">Tyler Williams</span>
                            </div>
                        </mat-card-header>

                        <mat-card-content>
                            <div class="d-flex flex-row bd-highlight mb-3">
                                <div class="bd-highlight" style="width: 50%">
                                    <img
                                        mat-card-image
                                        src="../../../assets/images/galaxy.jpg"
                                        alt="Photo of a Shiba Inu"
                                    />
                                </div>
                                <div class="bd-highlight px-2 py-1" style="width: 50%">
                                    <div class="content-title mb-2">Catalog name / package</div>
                                    <div class="content-description">
                                        Short description preview of the product and some, lorem ipsum dolor sit amet,
                                        consectetur adipiscing elit. Risus orci, sem nullam maecenas sed mauris. Sed
                                        turpis lorem vitae sit. Amet, in aliquet odio id orci...
                                    </div>
                                </div>
                            </div>

                            <div class="content-actions">
                                <div class="package-chips pb-2">
                                    <mat-chip-list aria-label="Fish selection">
                                        <mat-chip>weather</mat-chip>
                                        <mat-chip>oceanic</mat-chip>
                                        <mat-chip>streaming</mat-chip>
                                        <mat-chip>weather</mat-chip>
                                        <mat-chip>oceanic</mat-chip>
                                        <mat-chip>streaming</mat-chip>
                                    </mat-chip-list>
                                </div>
                                <div class="package-actions pt-2">
                                    <div class="d-flex bd-highlight">
                                        <div class="p-2 bd-highlight">
                                            <button
                                                mat-fab
                                                class="person-menu"
                                                [class.yellow]="isFavorite"
                                                aria-label="Example icon button with a delete icon"
                                                (click)="makeFavorite()"
                                            >
                                                <mat-icon>star_border</mat-icon>
                                            </button>
                                            <span class="px-2 content-nr">47</span>
                                        </div>
                                        <div class="p-2 bd-highlight">
                                            <button
                                                mat-fab
                                                class="person-menu"
                                                [class.yellow]="isFavorite"
                                                aria-label="Example icon button with a delete icon"
                                                (click)="makeFavorite()"
                                            >
                                                <mat-icon>collections</mat-icon>
                                            </button>
                                            <span class="px-2 content-nr">add to collection</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>

                <div class="col-md-12 col-lg-12 pb-2 package-div">
                    <mat-card class="example-card">
                        <div class="d-flex bd-highlight up-header mt-1 mb-3">
                            <div class="bd-highlight">Updated 5 min.</div>
                            <div class="ml-auto bd-highlight">2 downloaded</div>
                        </div>
                        <mat-card-header class="card-header-mat">
                            <div mat-card-avatar class="example-header-image">
                                <img
                                    src="../../../assets/images/user-female.png"
                                    alt="User image card"
                                    class="person-card-photo"
                                />
                                <span class="person-card-name">Tyler Williams</span>
                            </div>
                        </mat-card-header>

                        <mat-card-content>
                            <div class="content-text">
                                <div class="content-title mb-2">Catalog name / package</div>
                                <div class="content-description">
                                    Short description preview of the product and some, lorem ipsum dolor sit amet,
                                    consectetur adipiscing elit. Risus orci, sem nullam maecenas sed mauris. Sed turpis
                                    lorem vitae sit. Amet, in aliquet odio id orci...
                                </div>
                            </div>

                            <div class="content-actions">
                                <div class="package-chips pb-2">
                                    <mat-chip-list aria-label="Fish selection">
                                        <mat-chip>weather</mat-chip>
                                        <mat-chip>oceanic</mat-chip>
                                        <mat-chip>streaming</mat-chip>
                                        <mat-chip>weather</mat-chip>
                                        <mat-chip>oceanic</mat-chip>
                                        <mat-chip>streaming</mat-chip>
                                    </mat-chip-list>
                                </div>
                                <div class="package-actions">
                                    <div class="d-flex bd-highlight">
                                        <div class="p-2 bd-highlight">
                                            <button
                                                mat-fab
                                                class="person-menu"
                                                [class.yellow]="isFavorite"
                                                aria-label="Example icon button with a delete icon"
                                                (click)="makeFavorite()"
                                            >
                                                <mat-icon>star_border</mat-icon>
                                            </button>
                                            <span class="px-2 content-nr">47</span>
                                        </div>
                                        <div class="p-2 bd-highlight">
                                            <button
                                                mat-fab
                                                class="person-menu"
                                                [class.yellow]="isFavorite"
                                                aria-label="Example icon button with a delete icon"
                                                (click)="makeFavorite()"
                                            >
                                                <mat-icon>collections</mat-icon>
                                            </button>
                                            <span class="px-2 content-nr">add to collection</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
            <!-- package -->
        </div>
    </div>
</div>
